export function truncateLines(text: string, maxCharsPerLine = 50, lines = 2): string {
  const maxChars = maxCharsPerLine * lines
  if (text.length <= maxChars) return text
  return `${text.substring(0, maxChars).trim()}...`
}
